const days = {
	all: "Todos los días",
	mon: "Lunes",
	tue: "Martes",
	wed: "Miercoles",
	thu: "Jueves",
	fri: "Viernes",
	sat: "Sábado",
	sun: "Domingo",
};

export { days };
